import { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import {
  Grid,
  RadioGroup,
  Radio,
  FormControlLabel,
  Typography,
  Box,
} from '@mui/material';
import { AutocompleteV } from 'components';
import { RadioButtonIcon, RadioButtonIconFill } from 'components/CheckBox/RadioButtonIcon';
import { getCardService, getShebaService } from './services/RadioGroupCashoutService';
import { CircularProgress } from '@mui/material';
const RadioGroupCashout = forwardRef((props, ref) => {
  const { classes,
    control,
    errors,
    register,
    handleWithdrawal = () => { },
    cardInfoAcc,
    isDisable,
    isShow,
    isShowLoadingSeach,
    list,
    setList,
    setIsLoading,
    onInputChangeAutoCompelete,
    onChangeValueAutoCompelete,
    gridSize = { xs: 12, md: 4 },
    typeGridSize = gridSize,
    feeGridSize = gridSize,
    typeGridStyle = { marginInlineStart: 8 },
    beforeDestination = null,
    hideEmptyFeeGrid = false,
  } = props;

  const [cardLoadingData, setCardLoadingData] = useState(false);

  const getSheba = async () => {
    setIsLoading(true)

    const params = { offset: 0, size: 50 };
    getShebaService(params).then(result => {
      const dataSheba = result.result.map((res) => {
        return {
          label: res?.name ? `IR${res.shebaNumber} - ${res?.name}` : `IR${res.shebaNumber}`,
          value: res.shebaNumber,
        };
      });
      setList({ ...list, dataSheba });
      setIsLoading(false);
    }).catch(error => { })
  }


  const getCardData = () => {
    if (cardLoadingData) return;
    const params = { offset: 0, size: 50 };
    setCardLoadingData(true);
    getCardService(params).then(res => {

      const dataCard = res.map((sh) => {
        return {
          label: sh?.name ? `${sh.number} - ${sh?.name}` : sh.number,
          value: sh.number,
        };
      });

      setList({ ...list, dataCard });
      setCardLoadingData(false);
    }).catch(error => {
      setCardLoadingData(false);
    })

  }

  useImperativeHandle(ref, () => ({
    onGetSheba() {
      getSheba();
    },
    onGetCardData() {
      getCardData()
    }
  }));

  return (
    <>
      <Grid className={classes.grid} item {...typeGridSize} style={typeGridStyle}>
        <Typography variant="h6">
          {' '}
          <span className={classes.require}>*</span> نوع برداشت
        </Typography>

        <RadioGroup
          onChange={(e) => {
            handleWithdrawal(e);
            if (e.target.value === 'SETTLEMENT_TOOL_CARD' && !list?.dataCard)
              getCardData();
          }}
          row
          value={cardInfoAcc}
          defaultValue={cardInfoAcc}

        >
          <FormControlLabel
            value="SETTLEMENT_TOOL_PAYA"
            control={
              <Radio
                color="primary"
                icon={<RadioButtonIcon />}
                checkedIcon={<RadioButtonIconFill />}
              />
            }
            label="پایا"
            disabled={isDisable.isPayaDisable || cardLoadingData}
          />
          <FormControlLabel
            value="SETTLEMENT_TOOL_CARD"
            control={
              <Radio
                color="primary"
                icon={<RadioButtonIcon />}
                checkedIcon={<RadioButtonIconFill />}
              />
            }
            label="کارت بانکی"
            disabled={isDisable.isCardDisable || cardLoadingData}
          />
          <FormControlLabel
            value="SETTLEMENT_TOOL_SATNA"
            control={
              <Radio
                color="primary"
                icon={<RadioButtonIcon />}
                checkedIcon={<RadioButtonIconFill />}
              />
            }
            label="ساتنا"
            disabled={isDisable.isSatnaDisable || cardLoadingData}
          />
        </RadioGroup>
      </Grid>

      {beforeDestination}

      {isShow ? (
        <>
          <Grid className={classes.container} item {...gridSize}>
            <Box className={classes.grid} style={{ position: 'relative', width: '100%' }}>
              <AutocompleteV
                disabled={cardLoadingData}
                style={cardLoadingData ? { backgroundColor: 'rgb(237 237 237)' } : {}}
                control={control}
                errors={errors}
                register={register}
                name="cards"
                label="مقصد"
                rules={['required']}
                placeholder="مقصد"
                list={
                  cardInfoAcc === 'SETTLEMENT_TOOL_CARD' ? list?.dataCard : list?.dataSheba
                }
                
                onInputChange={(e) => {
                  onInputChangeAutoCompelete(e);
                 
                }}
                preventAddCustomOption={isShowLoadingSeach}
                loading={isShowLoadingSeach}
                onChangeValue={(newValue) => {
                  onChangeValueAutoCompelete(newValue);
                }}
              />

              {
                cardLoadingData &&
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>

                  <CircularProgress size={18} style={{ position: 'absolute', top: '45px' }} />
                </div>
              }
            </Box>
          </Grid>
          {(!hideEmptyFeeGrid || cardInfoAcc === 'SETTLEMENT_TOOL_CARD') && (
            <Grid className={classes.grid} item {...feeGridSize}>
              {cardInfoAcc === 'SETTLEMENT_TOOL_CARD' && (
                <Typography
                  variant="h6"
                  style={{
                    marginInlineStart: 4,
                    marginTop: 10,
                    marginBottom: 5,
                  }}
                >
                  مبلغ کارمزد از حساب شما کسر خواهد شد.
                </Typography>
              )}
            </Grid>
          )}
        </>
      ) : (
        ''
      )}
    </>
  );
});

export default RadioGroupCashout;